import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=40c59a41&scoped=true&"
import script from "./CardTitle.vue?vue&type=script&lang=js&"
export * from "./CardTitle.vue?vue&type=script&lang=js&"
import style0 from "./CardTitle.vue?vue&type=style&index=0&id=40c59a41&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/customerHome.css?vue&type=style&index=1&id=40c59a41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c59a41",
  null
  
)

export default component.exports